import { useContext } from 'react';
import { FlexContainer, ModalContext, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import { ShareModal } from 'Components/Modal/components';
import { TAXDOWN_ASSETS_DOMAIN } from 'Constants/domains';
import { BoxModes } from 'Types/common';
import * as Styled from './styles';
import { BoxProps } from './types';

const PLURAL_KEY = 'plural';

const Box = ({ mode, profit }: BoxProps): JSX.Element => {
  const { t } = useTranslation(locizeNS.MGM);
  const { showModal } = useContext(ModalContext);
  const openShareModal = (): void => {
    showModal({
      comp: <ShareModal isFiling={false} />,
    });
  };
  const tContext = profit.names.length > 1 && PLURAL_KEY;
  return (
    <Styled.Box direction="column" mode={mode}>
      {profit.names.length ? (
        <FlexContainer direction="column" gap="dimension_24">
          <Styled.Header direction="column">
            <Text type="paragraphs" size="M_M_S" color="dark">
              {t(`Referral.Tracking.Box.${mode}.Title`)}
            </Text>
            <Text type="paragraphs" size="L_XL_S" color="dark">
              {t(`Referral.Tracking.Box.friends`, {
                context: tContext,
                friends: profit.names.length,
              })}
            </Text>
          </Styled.Header>
          <Styled.Gain direction="column">
            <Text type="paragraphs" size="M_L_S" color="dark">
              {t(`Referral.Tracking.Box.${mode}.cta`)}
            </Text>
            <Text type="headline" size="M_L_L" color="dark">
              {`$${profit.total}`}
            </Text>
            {mode === BoxModes.paid && (
              <Text type="paragraphs" size="XS_S_S" color="fresh">
                {t(`Referral.Tracking.Box.paid.info`)}
              </Text>
            )}
          </Styled.Gain>
          <Styled.FriendsListAccordion size="s">
            <Text type="paragraphs" size="S_XL_S" color="dark">
              {t(`Referral.Tracking.Box.list`)}
            </Text>
            <FlexContainer direction="column" gap="dimension_32">
              {profit.names.map((name: string, index: number) => (
                <FlexContainer key={name} gap="dimension_16" align="center">
                  <Text type="paragraphs" color="dark" size="M_M_S">
                    {index + 1}
                  </Text>
                  <Text type="paragraphs" color="dark" size="M_M_S">
                    {name}
                  </Text>
                </FlexContainer>
              ))}
              <Styled.InviteLink type="button" onClick={openShareModal}>
                <Text type="paragraphs" color="fresh" size="S_XL_S" align="left">
                  {t(`Referral.Tracking.Box.${mode}.share`)}
                </Text>
              </Styled.InviteLink>
            </FlexContainer>
          </Styled.FriendsListAccordion>
        </FlexContainer>
      ) : (
        <Styled.EmptyContainer justify="space-between" gap="dimension_24">
          <Styled.EmptyTitle type="paragraphs" size="M_M_S">
            {t(`Referral.Tracking.Box.${mode}.empty`)}
          </Styled.EmptyTitle>
          <Styled.EmptyImage
            src={`${TAXDOWN_ASSETS_DOMAIN}/mgm/${mode}_empty.svg`}
            alt={`${mode}_empty`}
          />
          <Styled.InviteLink onClick={openShareModal}>
            <Text type="paragraphs" color="fresh" size="S_XL_S">
              {t(`Referral.Tracking.Box.share`)}
            </Text>
          </Styled.InviteLink>
        </Styled.EmptyContainer>
      )}
    </Styled.Box>
  );
};

export default Box;
